import React, { useEffect, useRef } from 'react';
import { useDrag, useDrop } from 'react-dnd';
import { Icon } from 'sunzi-components';
import { Device } from 'sunzi-utils';
import { ReactComponent as Add } from '../assets/add.svg';
import { ReactComponent as CloseCircle } from '../assets/close-circle.svg';
import styles from '../index.less';

interface PhotoProps {
  currentIndex: number;
  image: string | null;
  text: string;
  showDelete: boolean;
  imageOffset: ({ left: number; top: number })[];
  handleDeletePhoto: () => void;
  handleAddPhoto: () => void;
  handleDragPhoto: (oldIndex: number, newIndex: number) => void;
}

const Photo: React.FC<PhotoProps> = ({
  currentIndex,
  image,
  text,
  showDelete,
  imageOffset,
  handleDeletePhoto,
  handleAddPhoto,
  handleDragPhoto,
}) => {

  /** 拖拽容器 */
  const [{isDragging, offset}, drag, preview] = useDrag({
    type: 'UserImage',
    item: {
      index: currentIndex,
    },
    collect: monitor => ({
      isDragging: monitor.isDragging(),
      offset: monitor.getClientOffset(),
    }),
    // 没有图片时无法拖拽
    canDrag: () => !!image,
  });
  /** 接收容器 */
  const [, drop] = useDrop({
    accept: 'UserImage',
    drop: (item: any) => handleDragPhoto(currentIndex, item.index),
    collect: monitor => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
    }),
  });
  /** 图片容器 */
  const _element = useRef<HTMLDivElement>(null);
  drag(drop(_element));
  /** 图片外层容器 */
  const _imageElement = useRef<HTMLDivElement>(null);
  /** 是否是移动端 */
  const isMobile = Device.type() === 'mobile';

  useEffect(() => {
    if (_element.current && currentIndex < 2) {
      if (_imageElement.current) {
        imageOffset[currentIndex] = {
          left: _imageElement.current.offsetLeft,
          top: _imageElement.current.offsetTop,
        }
        return
      }
      imageOffset[currentIndex] = {
        left: _element.current.offsetLeft,
        top: _element.current.offsetTop,
      }
    }
  }, []);

  return (
    <div className={styles.imageWrapper}>
      {(isDragging && isMobile && image) && <img style={{ left: offset?.x, top: offset?.y }} src={image} />}
      {image ? (
        <div ref={_imageElement} className={styles.image}>
          {!isMobile && <img ref={preview} src={image} /> }
          <div
            ref={_element}
            style={{
              backgroundImage: `url(${image})`
            }}
            className={styles.content}
          />
          {showDelete ? (
            <Icon className={styles.iconWrapper} onClick={handleDeletePhoto}>
              <CloseCircle />
            </Icon>
          ) : null}
        </div>
      ) : (
        <div ref={_element} className={styles.add} onClick={handleAddPhoto}>
          <Icon className={styles.iconWrapper}>
            <Add />
          </Icon>
        </div>
      )}
      <div className={styles.text}>{text}</div>
    </div>
  );
};

export default Photo;
